import { ChakraBox } from '@equip.health/ui';

import OverviewLoading from '~/components/common/OverviewLoading';
import SectionHeader from '~/components/common/SectionHeader';
import { PatientTabs } from '~/lib/constants/patients.constants';
import { PatientTabsCollection } from '~/lib/hooks/usePatientTabsCollection';
import { useGetPatientInsightsDashboardReportLinkQuery } from '~/store/services/reports';

type Props = {
  patientId: string;
};

export const InsightsOverview = ({ patientId }: Props) => {
  const {
    data: patientInsightsDashboardReportLink,
    isFetching: isReportLinkLoading,
  } = useGetPatientInsightsDashboardReportLinkQuery(patientId);
  return (
    <>
      <SectionHeader
        action={{
          linkTo: PatientTabsCollection[PatientTabs.CLINICAL_PROFILE].subPath,
          patientId,
          rightLinkText: 'View clinical measurements',
        }}
        headerText="Insights"
      />
      <ChakraBox
        background="white"
        borderColor="neutral.line"
        borderRadius="16px"
        borderStyle="solid"
        borderWidth="1px"
        id="insights-overview-section"
        margin="1px"
        padding="4px"
      >
        {isReportLinkLoading && <OverviewLoading />}
        {!isReportLinkLoading && (
          <iframe
            height="400px"
            src={patientInsightsDashboardReportLink}
            title={`patient_insights_dashboard_report_${patientId}`}
            width="100%"
          />
        )}
      </ChakraBox>
    </>
  );
};
